/** @jsx jsx **/
import { jsx, Box, Flex } from 'theme-ui'
import { Close } from '~/components/icons/close'
import FilterSecondary from '~/components/filter/filter-secondary'
import useMediaQuery from '~/hooks/use-media-query'

const FilterHeader = ({
  handleShowFilter,
  showFilter,
  handleStockOnly,
  handleSortBy,
  isStockOnly,
  sortByOptions,
}) => {
  const isDesktopOrLaptop = useMediaQuery({
    query: breakpoints => `(min-device-width: ${breakpoints[2]})`,
  })

  const buttonLabel = () => {
    return showFilter ? (
      <Box as="span">
        CLOSE FILTER
        {isDesktopOrLaptop && (
          <Close
            sx={{
              ml: '16px',
            }}
          />
        )}
      </Box>
    ) : (
      <span>SHOW FILTER</span>
    )
  }
  return (
    <Flex
      as="header"
      sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        // borderTop: '1px solid',
        // borderTopColor: 'border',
      }}
    >
      <Box
        sx={{
          width: ['100%', null, null, 'unset'],
        }}
      >
        <button
          sx={{
            color: 'text',
            backgroundColor: 'transparent',
            fontSize: '14px',
            border: ['1px solid transparent', null, null, 'none'],
            height: ['62px', null, null, '34px'],
            width: '100%',
            // borderBottom: ['1px solid', null, null, '1px solid'],
            borderBottomColor: 'transparent',
            p: 0,
            position: 'relative',
            textAlign: 'initial',
            '::before': {
              content: [`${showFilter ? '"-"' : '"+"'}`, null, null, 'unset'],
              display: 'block',
              position: 'absolute',
              left: '100px',
            },
          }}
          onClick={handleShowFilter}
        >
          {buttonLabel()}
        </button>
      </Box>
      {/* {isDesktopOrLaptop && (
        <Flex
          sx={{
            alignItems: 'center',
          }}
        >
          <FilterSecondary
            handleStockOnly={handleStockOnly}
            isStockOnly={isStockOnly}
            handleSortBy={handleSortBy}
            sortByOptions={sortByOptions}
          />
        </Flex>
      )} */}
    </Flex>
  )
}

export default FilterHeader
